import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import { useAuth } from './context/AuthContext';
import { useApp } from './context/AppContext';
import AppLayout from './components/Layout/AppLayout';
import Login from './pages/Login';
import RegistroLocal from './pages/RegistroLocal';
import Dashboard from './pages/Dashboard';
import POS from './pages/POS';
import Inventario from './pages/Inventario';
import Movimientos from './pages/Movimientos';
import ListasPrecios from './pages/ListasPrecios';
import Categorias from './pages/Categorias';
import Clientes from './pages/Clientes';
import Ventas from './pages/Ventas';
import Caja from './pages/Caja';
import Cajas from './pages/Cajas';
import Sucursales from './pages/Sucursales';
import SucursalEditor from './pages/SucursalEditor';
import Ordenes from './pages/Ordenes';
import Usuarios from './pages/Usuarios';
import Domiciliarios from './pages/Domiciliarios';
import SuperadminPlataforma from './pages/SuperadminPlataforma';
import Roles from './pages/Roles';
import Reportes from './pages/Reportes';
import Configuracion from './pages/Configuracion';
import CuentasCobro from './pages/CuentasCobro';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const App = () => {
  const { snackbar, closeSnackbar } = useApp();

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<RegistroLocal />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="pos" element={<POS />} />
          <Route path="inventario" element={<Inventario />} />
          <Route path="movimientos" element={<Movimientos />} />
          <Route path="listas-precios" element={<ListasPrecios />} />
          <Route path="categorias" element={<Categorias />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="ventas" element={<Ventas />} />
          <Route path="caja" element={<Caja />} />
          <Route path="cajas" element={<Cajas />} />
          <Route path="sucursales" element={<Sucursales />} />
          <Route path="sucursales/:id" element={<SucursalEditor />} />
          <Route path="ordenes" element={<Ordenes />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="domiciliarios" element={<Domiciliarios />} />
          <Route path="superadmin" element={<SuperadminPlataforma />} />
          <Route path="roles" element={<Roles />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="configuracion" element={<Configuracion />} />
          <Route path="cuentas-cobro" element={<CuentasCobro />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={closeSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default App;
